import React from 'react';
import Relay from 'react-relay';
import { Route, withRouter } from 'react-router';
import session from '../../components/dashboard/session';
import TimeoutDialog from '../../components/modal/timeout';
import Product from '../../components/product';
import questionnaire from '../../components/questionnaire';
import consult from '../consult';
import { CompleteMutation } from '../shared/mutation';
import Loading from '../shared/qualify/loading';
import Dashboard from './dashboard';
import './preapproval.css';

export default ({ path, actionPipe }) => {
  const Questionnaire = questionnaire('Preapproval', path, actionPipe);
  const Preapproval = (props) => (
    <Product
      questionnaire={Questionnaire}
      dashboard={session(Dashboard)}
      path={path}
      actionPipe={actionPipe}
      {...props}
    />
  );

  const messages = [
    <h2 key="msg-a">
      <strong>Processing</strong> your information.
    </h2>,
    <h2 key="msg-b">
      Analyzing your <strong>pre-approval options</strong>.
    </h2>,
    <h2 key="msg-c">
      Matching you with a <strong>licensed advisor</strong>.
    </h2>
  ];

  const LoadingDialog = (props) => (
    <Loading actionPipe={actionPipe} path={path} messages={messages} {...props} />
  );

  return (
    <Route
      path={path}
      queries={{
        viewer: () => Relay.QL`query { viewer }`
      }}
      component={Relay.createContainer(withRouter(Preapproval), {
        fragments: {
          viewer: () => Relay.QL`
               fragment on Viewer {
                 id
                 consultPath
                 products {
                   apr
                   rate
                   loanTerm                   
                   amortizationType
                 }
                 ${Questionnaire.getFragment('viewer')}
                 activeLoan {
                   propertyType
                   occupancy
                   purchasePrice
                   downPayment
                   creditAgree
                   advisor
                }
                 primaryBorrower {
                   email
                 }
               }
             `
        }
      })}
    >
      <Route path="error" component={withRouter(TimeoutDialog(path))} />
      {consult}
      <Route
        path="complete"
        queries={{
          viewer: () => Relay.QL`query { viewer }`
        }}
        component={Relay.createContainer(withRouter(LoadingDialog), {
          fragments: {
            viewer: () => Relay.QL`
                   fragment on Viewer {
                     consultPath
                     products {
                       apr
                       rate
                       loanTerm
                       amortizationType
                     }
                     ${CompleteMutation.getFragment('viewer')}
                   }
                 `
          }
        })}
      />
    </Route>
  );
};



// WEBPACK FOOTER //
// ./src/products/preapproval/index.js